"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Message;
var _react = _interopRequireDefault(require("react"));
require("./styles.scss");
var _Icon = _interopRequireDefault(require("../Icon/Icon"));
var _utils = require("../../utils");
function Message(props) {
  const {
    type,
    priority,
    title,
    body,
    actionText,
    actionHandler,
    pageButtons,
    showCloseButton,
    onClose
  } = props;
  const {
    isMobile
  } = (0, _utils.useDeviceInfo)();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "tw-message tw-message--".concat(type, " tw-message--").concat(priority, " ").concat(isMobile ? 'tw-message--mobile' : '')
  }, type === 'toast' && /*#__PURE__*/_react.default.createElement("div", {
    className: "tw-message--left-side"
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: priority,
    className: "left-side--icon"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "tw-message--container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "tw-message--main-content"
  }, type === 'page' && /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: priority,
    className: "main-content--icon"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "tw-message--main-body"
  }, title && /*#__PURE__*/_react.default.createElement("div", {
    className: "tw-message--title-container"
  }, /*#__PURE__*/_react.default.createElement("h4", null, title)), typeof body === 'string' ? /*#__PURE__*/_react.default.createElement("p", null, body) : body, type === 'page' && pageButtons && pageButtons.length > 0 ? /*#__PURE__*/_react.default.createElement("div", {
    className: "tw-message--actions-container"
  }, pageButtons === null || pageButtons === void 0 ? void 0 : pageButtons.map((pageButton, index) => {
    const pageButtonWithKey = {
      ...pageButton,
      key: "page-button-".concat(index),
      props: {
        ...pageButton.props,
        size: pageButton.props.size || 'medium'
      }
    };
    return pageButtonWithKey;
  })) : null)), type === 'toast' && actionText ? /*#__PURE__*/_react.default.createElement("button", {
    onClick: actionHandler,
    className: "tw-message--action-text"
  }, actionText) : showCloseButton ? /*#__PURE__*/_react.default.createElement("button", {
    onClick: onClose,
    className: "icon-container"
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: "close",
    className: "page-message--close-icon"
  })) : null));
}